// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1A9XY","left":"StickyBox_left__GtE4e","right":"StickyBox_right__2-sgn"};